import { render } from "./SearchVouchersView.vue?vue&type=template&id=6a9f8e6d&ts=true"
import script from "./SearchVouchersView.vue?vue&type=script&lang=ts"
export * from "./SearchVouchersView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.31_vue@3.4.31_typescript@4.1.6__webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__